import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export default function useRefreshTrafficFineVehicleListOnRouteEnter({ isLoading, refreshVehicleList }) {
  const location = useLocation()
  const requestedLocationKeyRef = useRef('')

  useEffect(() => {
    if (requestedLocationKeyRef.current === location.key) {
      return
    }

    requestedLocationKeyRef.current = location.key

    if (isLoading) {
      return
    }

    void refreshVehicleList()
  }, [isLoading, location.key, refreshVehicleList])
}
